import Auth from 'routes/Auth/Module';
import Dashboard from 'routes/Home/Dashboard/Module';
import Guardian from 'routes/Home/Guardian/Module';
import Payroll from 'routes/Home/Payroll/Module';
import Basic from 'routes/Home/Basic/reducers';
import Evaluation360 from 'routes/Home/Evaluation360/reducers';
import Attendance from 'routes/Home/Attendance/reducers';
import Salary from 'routes/Home/Salary/reducers';
import Bulletin from 'routes/Home/Bulletin/reducers';
import Feed from 'routes/Home/Feed/reducers';
import Requests from 'routes/Home/Requests/reducers';
import ActivityLog from 'routes/Home/ActivityLog/Module';
import Laboratory from 'routes/Home/Test/Laboratory/Module';
import Map from 'routes/Home/Map/Map/Module';

export default {
  reducers: {
    Auth,
    Dashboard,
    Basic,
    Requests,
    Bulletin,
    Feed,
    ActivityLog,
    Evaluation360,
    Attendance,
    Salary,
    Map,
    Laboratory,
    Guardian,
    Payroll
  },
};
